import React,{useState} from 'react'
import api from '.././../../../../api/api'
import { useAlert } from '../../../../../context/AlertContext';


function GrievanceDocumentInput({ grievanceId, callBack}) {

  const {AppAlert} = useAlert();
  const [dialogStatus, setDialogStatus] = useState(false);

  const isPDF = (file) =>{
    if(file.type.match('application/pdf')){
        return true;
    }
    return false;
  }

  const uploadToServer = (formData) =>{
    api.post("/admin/grievance/attachment",formData,{
        headers: {
          'Content-Type': 'multipart/form-data'
        }
    }).then( (res)=>{  
        console.log("here in upload local success",res.data);
        callBack(res.data.filePath);
        setDialogStatus(false);
    }).catch( (error) => {
        console.log(error);
    })
  }

  const uploadDocument = (e) =>{
    if(!isPDF(e.target.files[0])){
        AppAlert("Invalid File Type","error");
        return false;
    }
    const chatUserInfo =JSON.parse(sessionStorage.getItem("chatUserInfo")); 
    let formData = new FormData();
    formData.append('fileType', "document");
    formData.append('grievanceId',grievanceId)
    formData.append('tmpFile', e.target.files[0]);
    uploadToServer(formData);
  }




  return (
    <>
      
        <input type='file'
            onChange={ (e)=>{ uploadDocument(e) } } 
            accept="application/pdf"
            id="pdfAttachment"
            className='d-none'
        ></input>
        <label htmlFor='pdfAttachment' className='btn btn-primary mx-2'>Upload PDF</label>
    </>
  )
}

export default GrievanceDocumentInput